import TaskType from '../Models/TaskType';
import DataGridRequest from './DataGridRequest';
export class TaskTypeRequest extends DataGridRequest<TaskType> {
    Url = '/api/v1/settings/task_types';
}
